module.exports = __webpack_public_path__ + "img/comp-analytics.5502dc65.png";